/**
 * Created with Intellij IDEA
 * @User : Abdellatif
 * @Date : 11/26/2020
 * @Time : 6:07 PM
 *
 **/

import React from "react";

const LoadingComponent = ({isLoading}) => {
  return (
    <div
      className={!isLoading ? "wrapper" :
        "wrapper loader modal-backdrop fade show bg-white loader-bg-position-modals"}
    />
  );
};

export default LoadingComponent;